import React, { useEffect, useState } from 'react';
import {
    Button,
    InputControl,
    Link,
    CheckboxControl,
    Row,
    Col,
    Container,
} from '@si-armes/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import DateInput from 'components/Commun/Form/Date/DateInput';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import SelectDepartements from 'components/form/referentiel/select/SelectDepartement';
import {
    API_DEMANDE_ARME_TROUVEE_URL,
    API_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
    CONTEXT_DEMANDE_ARME_TROUVEE,
    CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';
import { REGEX_RGA } from 'constants/contraintes.constants';
import { getMessageErreurChampManquant } from 'utils/utils';
import RoutesRatelier from '../../ratelier/routes';
import formaterDemandeArmeTrouvee from './components/FormaterDemandeArmeTrouvee';
import ModaleArme from '../../../../components/arme/modaleAjoutArme/ModaleArme';
import { getPath } from '../../../../utils/router';
import InfoChampsObligatoire from '../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const DemandeArmeTrouvee = ({
    postApi,
    getApi,
    reinitialiseApi,
    erreurDemandeArmeTrouvee,
    isLoadingDemandeArmeTrouvee,
    erreurGdr,
}) => {
    const hookForm = useForm();
    const { register, handleSubmit, formState, watch, clearErrors, getValues, setError } = hookForm;

    const { REACT_APP_RGA_URL } = process.env;

    const history = useHistory();

    const redirectionToRatelier = () => {
        history.push(getPath(RoutesRatelier));
    };

    const isValidNumeroRga = () => {
        return !('numeroRga' in formState.errors);
    };

    const isFormulaireValide = () => {
        return (
            watch('lieuDecouverte') &&
            watch('departementDecouverte') &&
            watch('dateDecouverte') &&
            watch('numeroRga') &&
            (watch('numeroCarcasse') || watch('hasNumeroSerie')) &&
            isValidNumeroRga()
        );
    };

    useEffect(() => {
        if (!erreurDemandeArmeTrouvee && isLoadingDemandeArmeTrouvee === false) {
            reinitialiseApi(CONTEXT_DEMANDE_ARME_TROUVEE);
        }
    }, [isLoadingDemandeArmeTrouvee, erreurDemandeArmeTrouvee]);

    const afficherErreurGdr = () => {
        setError('numeroRga', {
            type: 'manual',
            message: `Le format est incorrect`,
        });
    };

    useEffect(() => {
        const numeroRga = getValues('numeroRga');
        const regexRGA = new RegExp(REGEX_RGA);

        if (watch('numeroRga')) {
            if (regexRGA.test(numeroRga)) {
                getApi(
                    usagerClientReducer,
                    API_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA + numeroRga,
                    CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
                );
            } else {
                afficherErreurGdr();
            }
        } else {
            clearErrors('numeroRga');
        }
    }, [watch('numeroRga')]);

    useEffect(() => {
        if (erreurGdr === false) {
            clearErrors('numeroRga');
        } else {
            afficherErreurGdr();
        }
    }, [erreurGdr]);

    const onSubmit = (dataForm) => {
        if (dataForm && isFormulaireValide()) {
            const dataFormat = formaterDemandeArmeTrouvee(dataForm);

            reinitialiseApi(CONTEXT_DEMANDE_ARME_TROUVEE);
            postApi(
                usagerClientReducer,
                API_DEMANDE_ARME_TROUVEE_URL,
                dataFormat,
                CONTEXT_DEMANDE_ARME_TROUVEE,
            );
        }
    };
    const [modaleOuverte, setModaleOuverte] = useState(false);

    return (
        <Container>
            <ModaleArme
                message="trouvée"
                modaleOuverte={modaleOuverte}
                onClickFunction={redirectionToRatelier}
            />
            <Row>
                <Col col={12}>
                    <h1>
                        Renseigner les informations sur les circonstances de la mise en possession :{' '}
                    </h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <InfoChampsObligatoire />
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <h2>Informations sur la découverte : </h2>
                </Col>
            </Row>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                id="lieuDecouverte"
                                label="Commune/lieu dit de découverte *"
                                uppercase
                                {...register('lieuDecouverte', {
                                    required: getMessageErreurChampManquant('lieuDecouverte'),
                                })}
                                state={formState.errors?.lieuDecouverte ? 'error' : null}
                                message={formState.errors?.lieuDecouverte?.message}
                                required
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <SelectDepartements
                                id="departementDecouverte"
                                name="departementDecouverte"
                                label="Département de découverte *"
                                required
                                placeholder="-- Choisir une option --"
                                register={register('departementDecouverte', {
                                    required:
                                        getMessageErreurChampManquant('departementDecouverte'),
                                })}
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={3}>
                            <DateInput
                                id="dateDecouverte"
                                label="Date de découverte *"
                                name="dateDecouverte"
                                required
                                noFuture
                            />
                        </Col>
                    </Row>
                    <Row className="margin-top-md">
                        <Col col={12}>
                            <h2>Renseigner les informations sur l&apos;arme découverte : </h2>
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <InputControl
                                id="numeroRga"
                                label="Numéro RGA *"
                                name="numeroRga"
                                type="text"
                                maxLength="5"
                                uppercase
                                {...register('numeroRga', {
                                    required: getMessageErreurChampManquant('numeroRga'),
                                })}
                                state={formState.errors?.numeroRga ? 'error' : null}
                                message={formState.errors?.numeroRga?.message}
                                required
                            />
                        </Col>
                        <Col col={12} md={6}>
                            <Link
                                href={REACT_APP_RGA_URL}
                                icon="fr-fi-arrow-right-line"
                                target="_blank"
                            >
                                Rechercher le code correspondant au modèle de mon arme sur le RGA
                            </Link>
                        </Col>
                    </Row>
                    <Row gutters verticalAlign="bottom">
                        <Col col={12} lg={6}>
                            <InputControl
                                id="numeroCarcasse"
                                label={`Numéro de série${!watch('hasNumeroSerie') ? ' *' : ''}`}
                                uppercase
                                {...register('numeroCarcasse', {
                                    required: !watch('hasNumeroSerie'),
                                })}
                                state={formState.errors?.numeroCarcasse ? 'error' : null}
                                message={formState.errors?.numeroCarcasse?.message}
                                disabled={watch('hasNumeroSerie')}
                                required={!watch('hasNumeroSerie')}
                            />
                        </Col>
                        <Col col={12} md={6}>
                            <CheckboxControl
                                id="hasNumeroSerie"
                                name="hasNumeroSerie"
                                label="Cocher cette case si vous ne parvenez pas à identifier le numéro de série de l'arme"
                                value={false}
                                {...register('hasNumeroSerie')}
                                disabled={watch('numeroCarcasse')}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row gutters>
                        <Col col={12}>
                            <CheckboxControl
                                id="armeIsNeutralisee"
                                name="armeIsNeutralisee"
                                label="Cocher cette case si votre arme est neutralisée"
                                {...register('armeIsNeutralisee')}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row gutters className="margin-top-lg">
                        <Col lg={6}>
                            <Button
                                name="Annuler"
                                variant="secondary"
                                onClick={redirectionToRatelier}
                            >
                                Annuler
                            </Button>
                        </Col>
                        <Col lg={6} className="text-right">
                            <Button
                                name="envoyer"
                                type="submit"
                                variant="primary"
                                isLoading={isLoadingDemandeArmeTrouvee}
                                disabled={!isFormulaireValide()}
                                onClick={() => setModaleOuverte(true)}
                            >
                                Envoyer
                            </Button>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </Container>
    );
};

DemandeArmeTrouvee.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    erreurDemandeArmeTrouvee: PropTypes.bool,
    isLoadingDemandeArmeTrouvee: PropTypes.bool,
    erreurGdr: PropTypes.string,
};

export default connect(
    (state) => {
        const { erreur: erreurDemandeArmeTrouvee, isLoading: isLoadingDemandeArmeTrouvee } =
            state.armes.demandeArmeTrouveeHeritee.demandeArmeTrouvee;

        const { erreur: erreurGdr } = state.armes.recupererGdrParNumeroRga;

        return {
            erreurDemandeArmeTrouvee,
            isLoadingDemandeArmeTrouvee,
            erreurGdr,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(DemandeArmeTrouvee);
